"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    imageClassNames: function() {
        return imageClassNames;
    },
    useImageStyles_unstable: function() {
        return useImageStyles_unstable;
    }
});
const _react = require("@griffel/react");
const imageClassNames = {
    root: 'fui-Image'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ],
        Bbmb7ep: [
            "fzi6hpg",
            "fyowgf4"
        ],
        Beyfa6y: [
            "fyowgf4",
            "fzi6hpg"
        ],
        B7oj6ja: [
            "f3fg2lr",
            "f13av6d4"
        ],
        Btl43ni: [
            "f13av6d4",
            "f3fg2lr"
        ],
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f14t3ns0"
    },
    bordered: {
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ]
    },
    circular: {
        Bbmb7ep: [
            "f8fbkgy",
            "f1nfllo7"
        ],
        Beyfa6y: [
            "f1nfllo7",
            "f8fbkgy"
        ],
        B7oj6ja: [
            "f1djnp8u",
            "f1s8kh49"
        ],
        Btl43ni: [
            "f1s8kh49",
            "f1djnp8u"
        ]
    },
    rounded: {
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ]
    },
    square: {},
    shadow: {
        E5pizo: "f1whvlc6"
    },
    center: {
        st4lth: "f1plgu50",
        Ermj5k: "f14xojzb",
        Bqenvij: "f1l02sjl",
        a9b677: "fly5x3f"
    },
    contain: {
        st4lth: "f1kle4es",
        Ermj5k: "f14xojzb",
        Bqenvij: "f1l02sjl",
        a9b677: "fly5x3f"
    },
    "default": {},
    cover: {
        st4lth: "f1ps3kmd",
        Ermj5k: "f14xojzb",
        Bqenvij: "f1l02sjl",
        a9b677: "fly5x3f"
    },
    none: {
        st4lth: "f1plgu50",
        Ermj5k: [
            "f13uwng7",
            "fjmyj0p"
        ],
        Bqenvij: "f1l02sjl",
        a9b677: "fly5x3f"
    },
    block: {
        a9b677: "fly5x3f"
    }
}, {
    d: [
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}",
        ".fzi6hpg{border-bottom-right-radius:var(--borderRadiusNone);}",
        ".fyowgf4{border-bottom-left-radius:var(--borderRadiusNone);}",
        ".f3fg2lr{border-top-right-radius:var(--borderRadiusNone);}",
        ".f13av6d4{border-top-left-radius:var(--borderRadiusNone);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f14t3ns0{display:inline-block;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".f192inf7{border-top-width:var(--strokeWidthThin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        ".f8fbkgy{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f1nfllo7{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".f1djnp8u{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f1s8kh49{border-top-left-radius:var(--borderRadiusCircular);}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1whvlc6{box-shadow:var(--shadow4);}",
        ".f1plgu50{object-fit:none;}",
        ".f14xojzb{object-position:center;}",
        ".f1l02sjl{height:100%;}",
        ".fly5x3f{width:100%;}",
        ".f1kle4es{object-fit:contain;}",
        ".f1ps3kmd{object-fit:cover;}",
        ".f13uwng7{object-position:left top;}",
        ".fjmyj0p{object-position:right top;}"
    ]
});
const useImageStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(imageClassNames.root, styles.base, state.block && styles.block, state.bordered && styles.bordered, state.shadow && styles.shadow, styles[state.fit], styles[state.shape], state.root.className);
    return state;
}; //# sourceMappingURL=useImageStyles.styles.js.map
